export default {
  // ページタイトル
  title: {
    en: 'Log Management',
    ja: 'ログ管理',
  },

  // フィルター
  filters: {
    title: {
      en: 'Log Search',
      ja: 'ログ検索',
    },
    logLevel: {
      en: 'Log Level',
      ja: 'ログレベル',
    },
    startDate: {
      en: 'Start Date',
      ja: '開始日時',
    },
    endDate: {
      en: 'End Date',
      ja: '終了日時',
    },
    all: {
      en: 'All',
      ja: 'すべて',
    },
  },

  // テーブル
  table: {
    ariaLabel: {
      en: 'Log list',
      ja: 'ログ一覧',
    },
    id: {
      en: 'ID',
      ja: 'ID',
    },
    timestamp: {
      en: 'Timestamp',
      ja: 'タイムスタンプ',
    },
    level: {
      en: 'Level',
      ja: 'レベル',
    },
    message: {
      en: 'Message',
      ja: 'メッセージ',
    },
    file: {
      en: 'File',
      ja: 'ファイル',
    },
    line: {
      en: 'Line',
      ja: '行',
    },
    details: {
      en: 'Details',
      ja: '詳細',
    },
    actions: {
      en: 'Actions',
      ja: '操作',
    },
    noLogs: {
      en: 'No logs found',
      ja: 'ログが見つかりません',
    },
  },

  // メッセージ
  messages: {
    searchPlaceholder: {
      en: 'Search logs...',
      ja: 'ログを検索...',
    },
    loading: {
      en: 'Loading logs...',
      ja: 'ログを読み込み中...',
    },
  },
};
